import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28770786"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table table-hover align-middle products-table" }
const _hoisted_2 = { class: "pb-2 border-dark border-bottom" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Cnk", -1))
const _hoisted_7 = { class: "product-name" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["colspan"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BasePlaceholderTable = _resolveComponent("BasePlaceholderTable")!
  const _component_ProductSelectorLine = _resolveComponent("ProductSelectorLine")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", _hoisted_2, [
      _createElementVNode("tr", null, [
        (!_ctx.singleProduct)
          ? (_openBlock(), _createElementBlock("th", _hoisted_3))
          : _createCommentVNode("", true),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('name')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('priceInclVat')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('discount')), 1)
      ])
    ]),
    _createElementVNode("tbody", null, [
      (!_ctx.ready)
        ? (_openBlock(), _createBlock(_component_BasePlaceholderTable, {
            key: 0,
            "n-cols": _ctx.singleProduct ? 6 : 7
          }, null, 8, ["n-cols"]))
        : _createCommentVNode("", true),
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.productsOverview.results?.length)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _createElementVNode("td", {
                    colspan: _ctx.singleProduct ? 6 : 7,
                    class: "fw-bold small text-uppercase text-muted"
                  }, _toDisplayString(_ctx.$t('noResults')), 9, _hoisted_9)
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productsOverview.results.slice(0, 100), (product) => {
                    return (_openBlock(), _createBlock(_component_ProductSelectorLine, {
                      key: product.product.id,
                      class: "position-relative",
                      product: product,
                      errors: _ctx.errors,
                      onDataChanged: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('dataChanged'))),
                      "single-product": _ctx.singleProduct,
                      onCheckProduct: _ctx.changeSelection,
                      onSelectProduct: _ctx.selectProduct
                    }, null, 8, ["product", "errors", "single-product", "onCheckProduct", "onSelectProduct"]))
                  }), 128)),
                  (_ctx.productsOverview.results.length > 100)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
                        _createElementVNode("td", {
                          colspan: _ctx.singleProduct ? 6 : 7,
                          class: "fw-bold small text-muted"
                        }, _toDisplayString(_ctx.$t('moreResults')), 9, _hoisted_11)
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ]))
}